import React from 'react'

export const EtsyIcon = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={props.style}
    className={`icon--social icon--social-etsy ${props.className ||
    ''}`}
    viewBox='0 0 32 32'
  >
    <path
      d='M28,2.5H4C3.2,2.5,2.5,3.2,2.5,4V28c0,0.8,0.6,1.4,1.4,1.4H28c0.8,0,1.4-0.6,1.4-1.4V4C29.5,3.2,28.8,2.5,28,2.5z
	 M25.6,22.2c-0.2,1.5-0.4,3-0.5,4.4c-0.1,0.6,0,0.5-0.6,0.5c-6.1-0.1-12.2-0.3-18.3,0c0-0.4,0-0.8,0-1.3c0.6-0.1,1.1-0.2,1.7-0.3
	c0.6-0.1,1.2-0.3,1.3-1c0.2-3.4,0.1-6.8,0.1-10.2c0-2,0-4-0.1-6c0-1.1-0.3-1.5-1.4-1.7C6.1,6.2,6.1,6.7,6.2,5
	c6.2,0.1,12.4,0.4,18.6-0.2c-0.1,2.1-0.3,4.2-0.4,6.4c-0.4,0-0.7,0-1.1,0c-0.4-0.1-0.6-1.8-0.8-2.2c-0.3-1.1-0.9-2.3-2.3-2.2
	c-2.2,0-4.4,0-6.7,0c-0.6,0-0.6,0-0.6,0.6c0,2.6,0,5.3,0,7.9c1.6,0,3.1,0,4.6-0.1c0.8-0.1,1.1-0.3,1.3-1.1c0.7-2.4,0-2.1,1.9-2.1
	c0,2.6,0,5.1-0.1,7.6c0,0.3-0.1,0.4-0.4,0.4c-1,0-1,0-1.2-0.9c-0.2-1.1-0.4-2.1-1.8-2.1c-1.4,0-2.9-0.1-4.3,0c-0.1,2.2,0,4.5,0,6.7
	c0,1.3,0.5,1.9,1.8,2c2,0.1,4,0,6,0c1.2,0,2-0.7,2.6-1.8c0.4-0.9,0.8-1.7,1.2-2.6c0.3-0.8,0.8-0.4,1.4-0.5
	C25.8,21.1,25.7,21.7,25.6,22.2z'
    />
  </svg>
)
